// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mHXs","colBig":"styles_colBig__2BEsC","colSmall":"styles_colSmall__D6jN_","shopifyNameWrapper":"styles_shopifyNameWrapper__2zDws"};